// Banner de alerta do topo (§6.1): "N certificados expiram em menos
// de 30 dias" — o CTA aplica o filtro "só cert expirando" no painel.
import { TriangleAlertIcon } from "lucide-react"
import { useTranslation } from "react-i18next"

import { Button } from "@/components/ui/button"

const panelPrefix = "pages.adminProcessorConfig"

type ExpiringCertificatesBannerProps = {
  count: number
  onShowExpiring: () => void
}

export const ExpiringCertificatesBanner = ({
  count,
  onShowExpiring,
}: ExpiringCertificatesBannerProps) => {
  const { t } = useTranslation()
  if (count === 0) return null

  return (
    <div
      data-testid="expiring-certificates-banner"
      className="flex flex-col gap-3 rounded-xl border border-amber-200 bg-amber-50 p-4 sm:flex-row sm:items-center sm:justify-between"
    >
      <div className="flex items-center gap-3">
        <TriangleAlertIcon
          className="size-5 shrink-0 text-amber-600"
          aria-hidden="true"
        />
        <p className="text-sm font-medium text-amber-800">
          {t(`${panelPrefix}.expiringBanner`, { count })}
        </p>
      </div>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="shrink-0 border-amber-300 bg-white text-amber-800 hover:bg-amber-100"
        onClick={onShowExpiring}
      >
        {t(`${panelPrefix}.expiringBannerCta`)}
      </Button>
    </div>
  )
}
